export default {
  evaluation_list: {
    title: '평가 의뢰 기업 목록',
    // number_of_companies_answered: "",
    number_of_companies_displayed: '{total}건 중 {start}–{end}건 표시',
    company_name: '회사명',
    status: '상태',
    questionnaire: '조사표/서베이',
    plan: '요금제',
    nothing: '해당하는 기업이 없습니다.',
  },
  evidence_options: {
    all_plan: '모든 요금제',
    // plans_with_vouchers: "",
    // no_voucher_plan: "",
  },
  table_headers: {
    company_name: '회사명',
    status: '상태',
    esg_rating: 'ESG 등급',
    esg_score: 'ESG 스코어',
    environment: '환경',
    social: '사회',
    governance: '거버넌스',
    plan: '요금제',
    questionnaire: '조사표/서베이',
    answer_date: '응답일',
    answer_expires_date: '응답 기한',
  },
  plan_list: {
    // light: "",
    // starter: "",
    // basic: "",
    // standard: "",
    // enterprize: "",
  },
}
